import React from "react";

const OurStory = () => {
  return (
    <article className="about_our-story clearfix">
      <img
        src="/images/about/Our-Story.jpg"
        className="rightImg"
        alt="Jonathan Lim - Co-Founder and Mai Nguyen - Co-Founder"
        width={590}
        height={590}
      />
      <h2>Our Story</h2>
      <p>
        M﻿ai & John, Co-founders of the company, are travel professionals & real
        estate investors with over 15 years of experience in the Hospitality
        industry.
      </p>
      <p>
        In 2015, on a trip to Montreal, they decided to book an Airbnb stay vs a
        hotel as they needed more space to cook and feel at home.
      </p>
      <p>
        After enjoying using Airbnb as travelers, in 2017, they became a host on
        Airbnb, starting with a small apartment in Toronto.
      </p>
      <p>
        However, that was an entirely new experience and throughout their first
        2 years, they made a lot of mistakes, but they quickly learned and
        before you know it, became Superhosts and saw the potential of
        short-term rental as solutions for those looking to make extra income
        from their properties.
      </p>
      <p>
        During a Christmas party in 2019, they were introduced to a realtor
        specializing in investment properties, and seeing how Mai & John are
        experts on Airbnb, asked for their help to manage a few properties.
      </p>
      <p>
        And that’s how it all began. Since 2019, they have grown the company to
        hosting over 40 listings and have hosted over thousands of guests all
        across the GTA and surrounding areas.
      </p>
      <p>
        They continue to invest in new technology, softwares, education and
        growing the team to help maximize profitability for their clients.
      </p>
      <p>
        In 2022, with so many requests from owners who were making mistakes
        trying to do short-term rental on their own, they decided to launch a
        free monthly short-term rental workshop series as a way to give back and
        support others who are interested in learning how to get into the
        industry.
      </p>
    </article>
  );
};

export default OurStory;
